// src/pages/KeywordGridPage.js
import { VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { isEmpty } from 'lodash';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import StickyHeader from '../../components/StickyHeader';
import { LineButton } from '../../components/buttons/LineButton';
import RegularSolidButton from '../../components/buttons/RegularSolidButton';
import { KEYWORDS } from '../../utils/FanBuddyHelper';
import { t } from 'i18next';

const Title = styled.div`
  padding-top: calc(64px + env(safe-area-inset-top));
  text-align: left;
  font-size: 24px;
  font-weight: 700;
  line-height: 31px;
  margin: 16px 0;
  padding-left: 24px;
  padding-right: 24px;
  white-space: pre-wrap;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin: auto;
  padding: 20px;
  width: 100%;
`;

const SelectPersonalKeywordPage = () => {
  const [selectedKeywords, setSelectedKeywords] = useState([]); // 선택된 키워드를 저장할 상태
  const [showNextButton, setShowNextButton] = useState(false); // 다음 단계 버튼 표시 상태 추가

  const navigate = useNavigate();

  const handleKeywordClick = (keyword) => {
    setSelectedKeywords((prev) => {
      const updatedKeywords = prev.includes(keyword.key)
        ? prev.filter((key) => key !== keyword.key) // 이미 선택된 키워드라면 제거
        : [...prev, keyword.key]; // 선택되지 않은 키워드라면 추가

      // 선택된 키워드가 하나 이상일 경우 버튼 표시
      setShowNextButton(!isEmpty(updatedKeywords));
      return updatedKeywords;
    });
  };

  // 다음 단계로 이동하는 함수
  const handleNextStep = () => {
    const currentQueryParams = new URLSearchParams(window.location.search);
    navigate(
      `/fan-buddy/select-filter?keywords=${selectedKeywords.join(
        ','
      )}&${currentQueryParams.toString()}`
    );
  };

  const isSelectedKeyword = (keywordKey) => {
    return selectedKeywords.includes(keywordKey);
  };

  return (
    <>
      <StickyHeader
        title={t('FanBuddyPersonalKeyWord.pageTitle')}
        alwaysShowTitle={true}
        showBackButton={true}
      />
      <motion.div
        initial={{ opacity: 0, y: -10 }} // 위에서 아래로 이동
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <Title className="text-main-light-1 dark:text-main-dark-1 whitespace-pre-wrap">
          {t('FanBuddyPersonalKeyWord.description')}
        </Title>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, y: -10 }} // 위에서 아래로 이동
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.3 }}
      >
        <GridContainer>
          {KEYWORDS.map((keyword) => (
            <motion.div
              key={keyword.key}
              initial={{ scale: 0.95 }}
              animate={{ scale: 1 }}
              whileTap={{ scale: 0.98 }}
              transition={{
                type: 'spring',
                stiffness: 300,
                damping: 15
              }}
            >
              <LineButton
                key={keyword.key}
                isSelected={isSelectedKeyword(keyword.key)}
                onClick={() => handleKeywordClick(keyword)}
                text={keyword.value}
                style={{ minHeight: '82px', wordBreak: 'keep-all' }}
              />
            </motion.div>
          ))}
        </GridContainer>
      </motion.div>
      {showNextButton && (
        <VStack
          spacing={2}
          style={{
            position: 'fixed',
            bottom: 'calc(4px + env(safe-area-inset-bottom))',
            left: 0,
            right: 0,
            width: '100%',
            padding: '20px 0',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <RegularSolidButton
            text={t('FanBuddyPersonalKeyWord.nextButton')}
            onClick={handleNextStep}
            style={{
              fontSize: '15px',
              fontWeight: 500,
              padding: '16px 20px',
              width: 'calc(100% - 48px)',
              borderRadius: '8px'
            }}
          />
        </VStack>
      )}
    </>
  );
};

export default SelectPersonalKeywordPage;
